import { motion } from 'framer-motion';
import style from '../styles/housingDetailPageStyle.module.css';
import lokasiPerumStyle from '../components/lokasiPerumahan/lokasiPerumCompoStyle.module.css';
import '../../index.css';
import { Image, Title, Container, Center, createStyles } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import { Carousel } from '@mantine/carousel';
import NameHouseCompo from '../components/detailHouse/namehouse-component';
import ButtonCompo from '../components/button/button-component';
import ListFasilitasUnit from '../components/fasilitasUnit/listfasilitasunit-component';
import CarouselCompo3 from '../components/carousel3/carousel3-component';
import CardDekstopCompo from '../components/cardDekstop/carddekstop-component';
import InfoCardCompo from '../components/infoCard/infocard-component';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import SitePlanCompo from '../components/sitePlan/siteplan-component';
import CardMobileCompo from '../components/cardMobile/cardmobile-component';
import LokasiPerumCompo from '../components/lokasiPerumahan/lokasiperumahan-component';
import DenahTipeCompo from '../components/denahTipe/denahtipe-component';
import { useState, useEffect } from 'react';
import tennyIcon from '../assets/images/teenyicons.svg';
import Breadcrumbs2Component from '../components/breadcrumbs/breadcrumbs2-component';
import { FooterCompo } from '../components';
import {
  bathroom,
  bedroom,
  building,
  certificate,
  family,
  flash,
  frame,
  garage,
  garden,
  plate,
  sofa,
  water,
} from '../assets/images';
import DescHouseDetailCompo from '../components/DescriptionHouse/descriptionhousedetail-component copy';
import { type } from '@testing-library/user-event/dist/type';
import capitalizeWord from '../utility/capitalizeWord';
import { ReactSVG } from 'react-svg';

const useStyle = createStyles((theme) => ({
  image: {
    '@media (max-width: 600px)': {
      height: 246,
    },
  },
  CardDekstopContainer: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
    '@media (min-width: 600px)': {
      display: 'none',
    },
    '@media (min-width: 922px)': {
      display: 'block',
    },
  },
}));

const carouselCompo3Data = [
  {
    id: 1,
    image: require('../assets/images/gmb1.png'),
    icon: tennyIcon,
    title: 'Wijaya Kusuma',
    address: 'Jl Sudirman No 23 Kec. Kaliwates Bondowoso',
    link: 'https://play.google.com/store/apps/details?id=id.asc.sepakat',
  },
  {
    id: 2,
    image: require('../assets/images/gmb2.png'),
    title: 'Poncogati Regency',
    address: 'Jl Sudirman No 23 Kec. Kaliwates Bondowoso',
  },
  {
    id: 3,
    image: require('../assets/images/gmb3.png'),
    title: 'Griya Prajekan Asri',
    address: 'Jl Sudirman No 23 Kec. Kaliwates Bondowoso',
  },
  {
    id: 4,
    image: require('../assets/images/gmb4.png'),
    title: 'Wijaya Kusuma',
    address: 'Jl Sudirman No 23 Kec. Kaliwates Bondowoso',
  },
  {
    id: 5,
    image: require('../assets/images/gmb1.png'),
    title: '',
    address: '',
  },
];

const dataLokasi = [
  {
    icon: require('../assets/images/Card-Frame 502.png'),
    title: 'SD Jember Lor 1',
    time: '12 Menit',
  },
  {
    icon: require('../assets/images/Card-Frame 503.png'),
    title: 'ATM BCA',
    time: '3 Menit',
  },
  {
    icon: require('../assets/images/Card-Frame 502.png'),
    title: 'SPBU',
    time: '1 Menit',
  },
  {
    icon: require('../assets/images/Card-Frame 502.png'),
    title: 'BPJS',
    time: '2 Menit',
  },
  {
    icon: require('../assets/images/Card-Frame 502.png'),
    title: 'SMP 11 Jember',
    time: '5 Menit',
  },
];

const dataFasilitasUnit = [
  {
    icon: bathroom,
    title: '2 Kamar Mandi',
  },
  {
    icon: certificate,
    title: 'Surat Hak Milik',
  },
  {
    icon: bedroom,
    title: '2 Kamar Tidur',
  },
  {
    icon: garden,
    title: '1 Taman',
  },
  {
    icon: frame,
    title: '100 m2',
  },
  {
    icon: sofa,
    title: '1 Ruang Tamu',
  },
  {
    icon: building,
    title: '80 m2',
  },
  {
    icon: flash,
    title: '900 Volt',
  },
  {
    icon: plate,
    title: '1 Dapur',
  },
  {
    icon: water,
    title: 'PDAM',
  },
  {
    icon: family,
    title: 'Ruang Keluarga',
  },
  {
    icon: garage,
    title: 'Garasi',
  },
];

const dataNameHouse = [
  {
    type: 'Tipe 32',
    address: 'Wijaya Kusuma',
    price: 'Rp 900 jt',
    icon1: bathroom,
    icon2: bedroom,
    icon3: plate,
    icon4: garage,
    detail1: 1,
    detail2: 2,
    detail3: 1,
    detail4: 1,
  },
];

const dataDescriptionHouse = [
  {
    description1:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et magna eu lectus lobortis posuere ut eget turpis. Quisque sit amet nunc a risus rhoncus tempus. Nulla ut neque eros. Cras non lorem et sem dapibus accumsan eu sed augue. Aenean dolor magna, elementum at nunc a, egestas viverra massa. Maecenas feugiat sit amet felis non egestas. Sed volutpat lacus ex, nec rutrum lacus accumsan at. Donec nisl neque, tincidunt et viverra quis, sagittis ac elit. Phasellus eget purus eu dui fermentum dapibus. Cras lectus dui, malesuada eget eros vel, ultrices semper libero. Mauris placerat congue tincidunt. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et magna eu lectus lobortis posuere ut eget turpis. Quisque sit amet nunc a risus rhoncus tempus. Nulla ut neque eros. Cras non lorem et sem dapibus accumsan eu sed augue. Aenean dolor magna, elementum at nunc a, egestas viverra massa. Maecenas feugiat sit amet felis non egestas. Sed volutpat lacus ex, nec rutrum lacus accumsan at. Donec nisl neque, tincidunt et viverra quis, sagittis ac elit. Phasellus eget purus eu dui fermentum dapibus. Cras lectus dui, malesuada eget eros vel, ultrices semper libero. Mauris placerat congue tincidunt.',
  },
];

const dataCarouselTypeHouse = [
  {
    id: 1,
    image: require('../assets/images/GridImg1.png'),
    title: 'Type',
    address: 'Address',
  },
  {
    id: 2,
    image: require('../assets/images/GridImg1.png'),
    title: 'Type',
    address: 'Address',
  },
  {
    id: 3,
    image: require('../assets/images/GridImg1.png'),
    title: 'Type',
    address: 'Address',
  },
  {
    id: 4,
    image: require('../assets/images/GridImg1.png'),
    title: 'Type',
    address: 'Address',
  },
  {
    id: 5,
    image: require('../assets/images/GridImg1.png'),
    title: 'Type',
    address: 'Address',
  },
];

const HousingDetailPage = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [fetching, setFetching] = useState(false);
  const [fasilitas, setFasilitas] = useState(dataFasilitasUnit);
  const [carousel3, setCarousel3] = useState(carouselCompo3Data);
  const [card, setCard] = useState(dataLokasi);
  const [namehouse, setNameHouse] = useState(dataNameHouse);
  const [deschouse, setDescHouse] = useState(dataDescriptionHouse);
  const [typehouse, setTypehouse] = useState(null);
  const [property, setProperty] = useState(null);
  const { classes } = useStyle();

  async function fetchTypeProperty(property_id, uid) {
    fetch(`${process.env.REACT_APP_URL}/property/${property_id}/${uid}`)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        const element = res.data;
        console.log(element);
        setProperty(element);
        setTypehouse(element.type_house);
      });
  }
  useEffect(() => {
    const id = searchParams.get('id');
    const propertyId = searchParams.get('property_id');

    console.log(propertyId, id);

    if (!fetching) {
      fetchTypeProperty(propertyId, id).then((value) => setFetching(true));
    }
  }, [fetching, searchParams]);
  return (
    property &&
    typehouse && (
      <motion.div
        className={style.main}
        initial={{ width: 0 }}
        animate={{ width: '100%' }}
        exit={{ x: window.innerWidth, transition: { duration: 1 } }}
      >
        <div className={`container ${style.containerImage}`}>
          <Image
            src={typehouse?.images[0]}
            className={classes.image}
          />
        </div>
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 p-0 me-3">
                <NameHouseCompo
                  key={typehouse.id}
                  type={typehouse.name}
                  address={property.name}
                  price={typehouse.price}
                  icon1={typehouse.icon1}
                  unitFacilities={typehouse.unit_facilities}
                />
                <ButtonCompo />
                <DescHouseDetailCompo
                  key={typehouse.id}
                  description1={typehouse.description}
                />
                <Container>
                  <Title color="#F56600" size={20} mt={40} mb={10}>
                    Fasilitas Unit
                  </Title>
                </Container>
                <div className="row">
                  {typehouse.unit_facilities &&
                    Object.keys(typehouse.unit_facilities).map((key, idx) => {
                      return (
                        <div className="col-5 col-md-6 col-lg-4" 
                            key={idx}>
                          <ListFasilitasUnit
                            icon={key.icon}
                            title={capitalizeWord(key.replaceAll('_', ' '))}
                          />
                        </div>
                      );
                    })}
                </div>
                {/* <Container>
                <Title color="#F56600" size={20} mt={40} mb={10}>
                  Sarana & Prasarana
                </Title>
              </Container> */}
                {/* <SaranaPrasaranaCompo /> */}
                <Title mt={40} size={20} mb={20} color="#F56600">
                  Foto Lainnya
                </Title>
                <Carousel
                  controlsOffset="5%"
                  controlSize={40}
                  slideSize="88%"
                  slideGap="md"
                  align="start"
                  styles={{
                    control: {
                      '&[data-inactive]': {
                        opacity: 0.5,
                        cursor: 'default',
                      },
                    },
                  }}
                >
                  {/* {typehouse.images.map((item, key) => {
                    return (
                      <Carousel.Slide>
                        <CarouselCompo3
                          key={key}
                          image={item}
                          icon={item.icon}
                          title={item.title}
                          address={item.address}
                          link={item.link}
                        />
                      </Carousel.Slide>
                    );
                  })} */}
                </Carousel>
                <Container>
                  <Title color="#F56600" size={20} mt={40} mb={20}>
                    Perumahan Lainnya
                  </Title>
                </Container>
                <Carousel
                  className={classes.CardDekstopContainer}
                  controlsOffset="10%"
                  controlSize={40}
                  align="start"
                  height={400}
                  slideSize="10%"
                  classNames={{ control: classes.control }}
                  styles={{
                    control: {
                      '&[data-inactive]': {
                        opacity: 0.5,
                        cursor: 'default',
                      },
                    },
                  }}
                >
                  {/* {typehouse.map((item, key) => {
                    return (
                      <CardDekstopCompo
                        key={item.id}
                        image={item.images}
                        title={item.name}
                        address={item.property_type}
                      />
                    );
                  })} */}
                </Carousel>
                <Center>
                  <CardMobileCompo />
                </Center>
                <InfoCardCompo />
              </div>
              <div className="col-12 col-md-5 col-lg-5 p-0 mb-4">
                <Container className={style.container2}>
                  <Title color="#F56600" size={20} mb={20}>
                    Site Plan
                  </Title>
                </Container>
                {property.siteplan && (
                  <>
                    <h1>Siteplan</h1>
                    <div className={style.btnWrapper}>
                      <div className={style.containerStackImage}>
                        {property.siteplan?.background && (
                          <img
                            src={property.siteplan.background}
                            alt=""
                            className={`mb-3 ${style.sitePlanImg}`}
                          />
                        )}
                      </div>
                      <div className={style.stackImage}>
                        {property.siteplan?.image && (
                          <ReactSVG
                            aria-label="Description of the overall image"
                            beforeInjection={(error, svg) => {
                              if (error) {
                                console.error(error)
                                return
                              }
                              console.log(svg)
                              // const desc = document.createElementNS(
                              //   'http://www.w3.org/2000/svg',
                              //   'desc'
                              // );
                              // desc.innerHTML = 'A description';
                              // svg.prepend(desc);

                              // const title = document.createElementNS(
                              //   'http://www.w3.org/2000/svg',
                              //   'title'
                              // );
                              // title.innerHTML = 'A title';
                              // svg.prepend(title);
                            }}
                            role="img"
                            evalScripts="always"
                            fallback={() => <span>Error!</span>}
                            httpRequestWithCredentials={true}
                            loading={() => <span>Loading</span>}
                            onClick={() => {
                              console.log('wrapper onClick')
                            }}
                            renumerateIRIElements={false}
                            src="svg.svg"
                            useRequestCache={false}
                            wrapper="span"
                          />
                        )}
                        {/* <Image
                            src={property.siteplan.image}
                            className={`mb-3 ${style.sitePlanImg}`}
                          /> */}
                      </div>
                      <a href="https://play.google.com/store/apps/details?id=id.asc.sepakat" target="_blank" rel="noreferrer">
                      <button
                        type="button"
                        className={`btn btn-success rounded-pill ${style.tombolSitePlan}`}
                      >
                        <p className="m-0">Buka Siteplan</p>
                      </button>
                      </a>
                    </div>
                  </>
                )}
                <h1>Lokasi Perumahan</h1>
                <div
                  className={`${lokasiPerumStyle.lokasiPerumahan} p-3 rounded-4 shadow-lg mb-5 bg-body rounded mt-4`}
                >
                  {property.near_facilities?.map((item, key) => {
                    return (
                      <LokasiPerumCompo
                        key={key}
                        icon={require('../assets/images/Card-Frame 502.png')}
                        title={item.name}
                        time={item.mileage + ' Menit'}
                      />
                    );
                  })}
                  </div>
                {/* <Container>
                  <Title color="#F56600" size={20} mb={20}>
                    Denah Tipe
                  </Title>
                </Container>
                <DenahTipeCompo /> */}
              </div>
            </div>
          </div>
        </div>
        <JumboTron2 />
        <FooterCompo />
      </motion.div>
    )
  );
};
export default HousingDetailPage;
